<template>
  <div
    :class="`modal fade ${customModalClass}`"
    aria-hidden="true"
    aria-labelledby="id-modal-title"
    id="id-modal-container"
    @click="clickOnModal"
  >
    <div
      class="modal-dialog"
      id="id-modal-dialog"
      :class="{
        'modal-dialog-centered': centered
      }"
    >
      <div class="modal-content common-modal-content">
        <div class="modal-header bg-light">
          <h5 class="modal-title" id="id-modal-title">{{title}}</h5>
          <button 
            ype="button"
            data-dismiss="modal"
            class="close"
            aria-label="Close"
            id="id-modal-close-button"
            @click="$emit('onClose', true)"
          ><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
export default {
  name: "CommonModal",
  props: {
    isOpen: Boolean,
    title: String,
    actionButton: String,
    customModalClass: String,
    centered: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    clickOnModal($event) {
      const modalDialog = document.getElementById("id-modal-dialog");
      const composedPath = $event.composedPath();
      const isInPath = composedPath.indexOf(modalDialog);
      if (isInPath < 0) {
        this.$emit("onClose");
      }
    }
  }
};
</script>
